import { Component, Input, OnInit } from '@angular/core';
import { UtilityService } from 'app/core/services/utility_functions/utility_functions.service';

@Component({
  selector: 'app-route-job-popup',
  templateUrl: './route-job-popup.component.html',
  styleUrls: ['./route-job-popup.component.scss']
})
export class RouteJobPopupComponent implements OnInit {

  @Input() data: any;

  constructor(public utilityService: UtilityService) { }

  ngOnInit(): void {
  }

}
